export default __webpack_public_path__ + "static/media/Visa.1fd3a698.svg";